import mbcService from '@/services/mbcService';

// function與action對照表
const actionLookUp = {
  Notification: 'refreshMemberNoticeUnreadCount',
};

export default {
  namespaced: true,
  state: {
    // 個人通知
    Notification: 0,
  },
  mutations: {
    set(state, { name, value }) {
      state[name] = value;
    },
    push(state, { name, value }) {
      state[name].push(value);
    },
    delete(state, { name }) {
      state[name] = null;
    },
  },
  actions: {
    // 刷新所有badge
    refreshAllBadge: ({ dispatch }) => {
      dispatch('getMemberCenterMenu', null, { root: true })
        .then((menus) => {
          // 取得menu中的function名稱
          const functionNames = menus
            .reduce((functions, menu) => functions.concat(menu.function), [])
            .map((func) => func.name);

          functionNames.forEach((name) => {
            // 依function名稱找出刷新badge的action
            const actionName = actionLookUp[name];
            // 找不到對應的action，表示該function沒有badge
            if (!actionName) return;
            // 執行action
            dispatch(actionName);
          });
        });
    },
    // 刷新個人通知未讀數
    refreshMemberNoticeUnreadCount: ({ commit, rootState }) => {
      const headers = { accessToken: rootState.accessToken };
      const params = { dayFilter: 90 };
      return mbcService.getMemberNoticeUnreadCount(params, headers)
        .toPromise()
        .then((res) => {
          commit('set', { name: 'Notification', value: res.response.data[0].unreadCount });
        });
    },
  },
};
